(function () {
  'use strict';

  function inject() {
    var block = document.querySelector('.dd-fg-wrapper.dd-fg-pending');
    if (!block) return true;

    var container = document.querySelector('.product-form__buttons');
    if (!container) return false;

    container.insertBefore(block, container.firstChild);
    block.classList.remove('dd-fg-pending');
    return true;
  }

  function start() {
    if (inject()) return;

    var observer = new MutationObserver(function () {
      if (inject()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();